/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ObjectObjectConfiguration as __Configuration } from '../object-object-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
class StatisticsService extends __BaseService {
  static readonly getStatisticsPath = '/statistics';
  static readonly getIpDetailPath = '/statistics';
  static readonly getStatisticsDetailPath = '/statistics/{spaceId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Get Statistic Details.
   * @param params The `StatisticsService.GetStatisticsParams` containing the following parameters:
   *
   * - `paginate`: Limit value for pagination.
   *
   * - `page`: Pagination value for member space list.
   *
   * - `Authorization`:
   *
   * - `filter`: Filterdate
   */
  getStatisticsResponse(params: StatisticsService.GetStatisticsParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.paginate != null) __params = __params.set('paginate', params.paginate.toString());
    if (params.page != null) __params = __params.set('page', params.page.toString());
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    if (params.filter != null) __params = __params.set('filter', params.filter.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/statistics`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Get Statistic Details.
   * @param params The `StatisticsService.GetStatisticsParams` containing the following parameters:
   *
   * - `paginate`: Limit value for pagination.
   *
   * - `page`: Pagination value for member space list.
   *
   * - `Authorization`:
   *
   * - `filter`: Filterdate
   */
  getStatistics(params: StatisticsService.GetStatisticsParams): __Observable<null> {
    return this.getStatisticsResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Get Ip Details.
   * @param body Update Visitors.
   */
  getIpDetailResponse(body?: {}): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/statistics`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Get Ip Details.
   * @param body Update Visitors.
   */
  getIpDetail(body?: {}): __Observable<null> {
    return this.getIpDetailResponse(body).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Get Statistic Details with id.
   * @param params The `StatisticsService.GetStatisticsDetailParams` containing the following parameters:
   *
   * - `spaceId`: Uuid value.
   *
   * - `Authorization`:
   *
   * - `filter`: Filterdate
   */
  getStatisticsDetailResponse(params: StatisticsService.GetStatisticsDetailParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    if (params.filter != null) __params = __params.set('filter', params.filter.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/statistics/${encodeURIComponent(String(params.spaceId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Get Statistic Details with id.
   * @param params The `StatisticsService.GetStatisticsDetailParams` containing the following parameters:
   *
   * - `spaceId`: Uuid value.
   *
   * - `Authorization`:
   *
   * - `filter`: Filterdate
   */
  getStatisticsDetail(params: StatisticsService.GetStatisticsDetailParams): __Observable<null> {
    return this.getStatisticsDetailResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module StatisticsService {

  /**
   * Parameters for getStatistics
   */
  export interface GetStatisticsParams {

    /**
     * Limit value for pagination.
     */
    paginate: number;

    /**
     * Pagination value for member space list.
     */
    page: number;
    Authorization: string;

    /**
     * Filterdate
     */
    filter?: string;
  }

  /**
   * Parameters for getStatisticsDetail
   */
  export interface GetStatisticsDetailParams {

    /**
     * Uuid value.
     */
    spaceId: string;
    Authorization: string;

    /**
     * Filterdate
     */
    filter?: string;
  }
}

export { StatisticsService }
